export const sellCarConstant = {
    GET_SELLCAR_REQUEST: "GET_SELLCAR_REQUEST",
    GET_SELLCAR_SUCCESS: "GET_SELLCAR_SUCCESS",
    GET_SELLCAR_FAILURE: "GET_SELLCAR_FAILURE"
};